interface BannerProps {
  title: string;
  backgroundImage: string;
}

export const Banner = ({ title, backgroundImage }: BannerProps) => {
  return (
    <div
      className="flex h-[40dvh] w-full items-end justify-start overflow-x-hidden bg-cover bg-center bg-no-repeat px-4 py-8 ph:px-24 ph:py-16 md:px-48 lg:px-72 xl:px-96"
      style={{
        backgroundImage: `linear-gradient(rgba(25, 25, 25, 0.75), rgba(25, 25, 25, 0.75)), url(${backgroundImage})`,
      }}
    >
      <h1 className="text-start font-cormorant text-4xl uppercase text-white ph:text-5xl sm:text-6xl lg:text-7xl">
        {title}
      </h1>
    </div>
  );
};
